var _a;
import { __assign, __spreadArrays } from "tslib";
import { ScenarioConditionType, ScenarioOperator, spotterEmptyConditionMap, } from "./conditions";
import { ScenarioActionType, spotterEmptyActionMap, } from "./actions";
import { agentStatusTrigger, articleTrigger, callStatusGroupTrigger, callStatusTrigger, customFieldTrigger, csatTrigger, emptyTrigger, numberTrigger, participantsTrigger, percentTrigger, priorityChangeTrigger, replyTypesTrigger, ticketStatusTrigger, timePeriodTrigger, callChannelTrigger, } from "./triggers";
import { WebNotificationType } from "../common";
import { Channel, TicketStatus } from "../tickets";
import { CallType, ExtendedCallStatus } from "..";
import { isFeatureEnabled } from "@wix/answers-experiments";
export var RecipeType;
(function (RecipeType) {
    RecipeType[RecipeType["FIX_UNHELPFUL_ARTICLES"] = 10] = "FIX_UNHELPFUL_ARTICLES";
    RecipeType[RecipeType["REDUCE_CALLBACK_WAIT_TIME"] = 20] = "REDUCE_CALLBACK_WAIT_TIME";
    RecipeType[RecipeType["REDUCE_TICKET_HANDLING_DELAYS"] = 30] = "REDUCE_TICKET_HANDLING_DELAYS";
    RecipeType[RecipeType["AUTOMATE_ABANDONED_CHAT_RESOLUTION"] = 40] = "AUTOMATE_ABANDONED_CHAT_RESOLUTION";
    RecipeType[RecipeType["REMOVE_IRRELEVANT_KNOWN_ISSUES"] = 60] = "REMOVE_IRRELEVANT_KNOWN_ISSUES";
    RecipeType[RecipeType["DETECT_LONG_CALLS"] = 70] = "DETECT_LONG_CALLS";
    RecipeType[RecipeType["MONITOR_CALL_CENTER_PRODUCTIVITY"] = 80] = "MONITOR_CALL_CENTER_PRODUCTIVITY";
    RecipeType[RecipeType["TICKET_PENDING"] = 90] = "TICKET_PENDING";
    RecipeType[RecipeType["ESCALATE_STUCK_TICKETS"] = 100] = "ESCALATE_STUCK_TICKETS";
    RecipeType[RecipeType["KEEP_ARTICLES_UP_TO_DATE"] = 110] = "KEEP_ARTICLES_UP_TO_DATE";
    RecipeType[RecipeType["DETECT_TICKET_PING_PONG"] = 120] = "DETECT_TICKET_PING_PONG";
    RecipeType[RecipeType["AUTOMATE_AGENT_RESPONSE_IN_CHAT"] = 130] = "AUTOMATE_AGENT_RESPONSE_IN_CHAT";
    RecipeType[RecipeType["MONITOR_AGENT_CALL_CENTER_STATUS"] = 190] = "MONITOR_AGENT_CALL_CENTER_STATUS";
    RecipeType[RecipeType["ALERT_CALL_CENTER_WORKLOAD"] = 200] = "ALERT_CALL_CENTER_WORKLOAD";
    RecipeType[RecipeType["AGENT_TRANSFER_COUNTER"] = 210] = "AGENT_TRANSFER_COUNTER";
    RecipeType[RecipeType["TAG_INCOMPLETE_CALLS"] = 220] = "TAG_INCOMPLETE_CALLS";
    RecipeType[RecipeType["OPTIMIZE_LINKING_TICKETS_WITH_ARTICLES"] = 230] = "OPTIMIZE_LINKING_TICKETS_WITH_ARTICLES";
    RecipeType[RecipeType["ALERT_COMPANIES_TICKET_VOLUME"] = 240] = "ALERT_COMPANIES_TICKET_VOLUME";
    RecipeType[RecipeType["AGENT_LINKING_KPI"] = 260] = "AGENT_LINKING_KPI";
    RecipeType[RecipeType["ALERT_OPEN_TICKETS_VOLUME"] = 270] = "ALERT_OPEN_TICKETS_VOLUME";
    RecipeType[RecipeType["REDUCE_CHAT_WAIT_TIME"] = 280] = "REDUCE_CHAT_WAIT_TIME";
    RecipeType[RecipeType["REDUCE_INBOUND_CALLS_WAIT_TIME"] = 290] = "REDUCE_INBOUND_CALLS_WAIT_TIME";
    RecipeType[RecipeType["ALERT_WHEN_PRIORITY_CHANGED"] = 300] = "ALERT_WHEN_PRIORITY_CHANGED";
    RecipeType[RecipeType["NOTIFY_ABOUT_UNHAPPY_CUSTOMERS"] = 310] = "NOTIFY_ABOUT_UNHAPPY_CUSTOMERS";
    RecipeType[RecipeType["TICKET_HAS_NOT_BEEN_ANSWERED"] = 320] = "TICKET_HAS_NOT_BEEN_ANSWERED";
    RecipeType[RecipeType["HANDLE_TICKETS_ASSIGNED_TO_DELETED_AGENT"] = 350] = "HANDLE_TICKETS_ASSIGNED_TO_DELETED_AGENT";
    RecipeType[RecipeType["HANDLE_VOICEMAIL_MESSAGES"] = 370] = "HANDLE_VOICEMAIL_MESSAGES";
    RecipeType[RecipeType["TICKET_ASSIGNED_TO_AGENT_ON_LEAVE"] = 400] = "TICKET_ASSIGNED_TO_AGENT_ON_LEAVE";
    RecipeType[RecipeType["HANDLE_UNANSWERED_CALLBACKS"] = 410] = "HANDLE_UNANSWERED_CALLBACKS";
    RecipeType[RecipeType["DELETE_OUTDATED_CALL_RECORDINGS"] = 500] = "DELETE_OUTDATED_CALL_RECORDINGS";
    RecipeType[RecipeType["MONITOR_AGENT_SESSIONS"] = 520] = "MONITOR_AGENT_SESSIONS";
    RecipeType[RecipeType["NOTIFY_CUSTOM_FIELD_UPDATED"] = 530] = "NOTIFY_CUSTOM_FIELD_UPDATED";
    RecipeType[RecipeType["NOTIFY_TICKET_ASSIGNED_TO_AGENT_OR_GROUP"] = 540] = "NOTIFY_TICKET_ASSIGNED_TO_AGENT_OR_GROUP";
    RecipeType[RecipeType["MONITOR_AGENT_CHAT_TRANSFERS"] = 560] = "MONITOR_AGENT_CHAT_TRANSFERS";
    RecipeType[RecipeType["REDUCE_TRANSFERRED_CALL_WAIT_TIME"] = 570] = "REDUCE_TRANSFERRED_CALL_WAIT_TIME";
    RecipeType[RecipeType["REDUCE_TRANSFERRED_CHAT_WAIT_TIME"] = 580] = "REDUCE_TRANSFERRED_CHAT_WAIT_TIME";
    RecipeType[RecipeType["CALL_TRANSFERRED"] = 1000] = "CALL_TRANSFERRED";
    RecipeType[RecipeType["TICKET_CREATED"] = 1010] = "TICKET_CREATED";
})(RecipeType || (RecipeType = {}));
export var ScenarioCategory;
(function (ScenarioCategory) {
    ScenarioCategory["ATTENTION"] = "attention";
    ScenarioCategory["OPERATIONS"] = "operations";
    ScenarioCategory["PRODUCTIVITY"] = "productivity";
    ScenarioCategory["QUALITY_OF_SERVICE"] = "quality-of-service";
})(ScenarioCategory || (ScenarioCategory = {}));
export var CustomFieldOptionType;
(function (CustomFieldOptionType) {
    CustomFieldOptionType["TICKET"] = "ticketCustomField";
    CustomFieldOptionType["COMPANY"] = "companyCustomField";
    CustomFieldOptionType["USER"] = "customerCustomField";
    CustomFieldOptionType["AGENT"] = "teamMemberCustomField";
})(CustomFieldOptionType || (CustomFieldOptionType = {}));
export var ScenarioModule;
(function (ScenarioModule) {
    ScenarioModule["KB"] = "kb";
    ScenarioModule["CC"] = "cc";
    ScenarioModule["CHAT"] = "chat";
    ScenarioModule["TICKETS"] = "tickets";
    ScenarioModule["TEAM_MEMBERS"] = "team-members";
    ScenarioModule["TICKET_SCORING"] = "ticket-scoring";
})(ScenarioModule || (ScenarioModule = {}));
export var InlineTimePeriodType;
(function (InlineTimePeriodType) {
    InlineTimePeriodType[InlineTimePeriodType["DAYS_HOURS"] = 0] = "DAYS_HOURS";
    InlineTimePeriodType[InlineTimePeriodType["HOURS_MINUTES"] = 1] = "HOURS_MINUTES";
    InlineTimePeriodType[InlineTimePeriodType["DAYS_HOURS_MINUTES"] = 2] = "DAYS_HOURS_MINUTES";
})(InlineTimePeriodType || (InlineTimePeriodType = {}));
export var getDefaultActions = function (recipeType) {
    var configuration = spotterScenarioDefinitions(recipeType);
    var emptyNotificationAction = spotterEmptyActionMap(ScenarioActionType.SEND_NOTIFICATION);
    var mandatoryActionsForRecipe = configuration.defaultActions ? configuration.defaultActions.map(function (actionType) { return spotterEmptyActionMap(actionType); }) : [emptyNotificationAction];
    var defaultActions = __spreadArrays(mandatoryActionsForRecipe);
    return defaultActions;
};
export var getMandatoryConditions = function (recipeType) {
    var configuration = spotterScenarioDefinitions(recipeType);
    return configuration.mandatoryConditions ?
        configuration.mandatoryConditions.map(function (conditionType) { return spotterEmptyConditionMap(conditionType); }) : [];
};
export var creteEmptyScenario = function (recipeType) {
    var defaultActions = getDefaultActions(recipeType);
    var mandatoryConditions = getMandatoryConditions(recipeType);
    return __assign({ recipeType: recipeType, 
        // disabled: false,
        actions: defaultActions, mustConditions: mandatoryConditions }, scenarioTriggerMap[recipeType]);
};
export var spotterScenarioDefinitions = function (recipeType) {
    var _a, _b, _c;
    var scenarioDefinitionMap = (_a = {},
        _a[RecipeType.TICKET_PENDING] = {
            scenarioType: RecipeType.TICKET_PENDING,
            actions: [
                ScenarioActionType.CHANGE_TICKET_STATUS,
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.ADD_AGENT_REPLY,
                ScenarioActionType.REASSIGN_TICKET,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD
            ],
            mustConditions: [
                ScenarioConditionType.TICKET_PRIORITY,
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.TICKET_MAILBOX,
                ScenarioConditionType.TICKET_CHANNEL,
                ScenarioConditionType.TICKET_ASSIGNEE,
                ScenarioConditionType.TICKET_REPLIES_COUNT,
                ScenarioConditionType.COMPANY,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            notification: {
                notificationType: WebNotificationType.SPOTTER_TICKET_PENDING,
                dynamicNotificationTypes: ['toRelevantAgent', 'toRelevantAgentManager']
            },
            modules: [ScenarioModule.TICKETS],
            categories: [
                ScenarioCategory.QUALITY_OF_SERVICE,
                ScenarioCategory.PRODUCTIVITY,
            ],
            triggerOptionsOverrides: {
                excludedTicketStatuses: [TicketStatus.PENDING],
            },
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.COMPANY, CustomFieldOptionType.USER]
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.COMPANY, CustomFieldOptionType.USER, CustomFieldOptionType.AGENT]
            },
            canApplyToSnoozedTickets: true,
        },
        _a[RecipeType.FIX_UNHELPFUL_ARTICLES] = {
            scenarioType: RecipeType.FIX_UNHELPFUL_ARTICLES,
            actions: [
                ScenarioActionType.CREATE_ARTICLE_TASK,
                ScenarioActionType.SEND_NOTIFICATION,
            ],
            mustConditions: [],
            modules: [ScenarioModule.KB],
            categories: [ScenarioCategory.QUALITY_OF_SERVICE],
            notification: {
                notificationType: WebNotificationType.SPOTTER_SPOT_AND_FIX_UNHELPFUL_ARTICLES,
                dynamicNotificationTypes: ['toArticleAuthor', 'toArticleAuthorManager']
            }
        },
        _a[RecipeType.REMOVE_IRRELEVANT_KNOWN_ISSUES] = {
            scenarioType: RecipeType.REMOVE_IRRELEVANT_KNOWN_ISSUES,
            actions: [
                ScenarioActionType.CREATE_ARTICLE_TASK,
                ScenarioActionType.SEND_NOTIFICATION,
            ],
            mustConditions: [ScenarioConditionType.LOCALE,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.ARTICLE_CATEGORY,
            ],
            modules: [ScenarioModule.KB],
            categories: [ScenarioCategory.OPERATIONS],
            notification: {
                notificationType: WebNotificationType.SPOTTER_REMOVE_IRRELEVANT_KNOWN_ISSUES,
                dynamicNotificationTypes: ['toArticleAuthor', 'toArticleAuthorManager']
            }
        },
        _a[RecipeType.REDUCE_TICKET_HANDLING_DELAYS] = {
            scenarioType: RecipeType.REDUCE_TICKET_HANDLING_DELAYS,
            actions: [
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.ADD_AGENT_REPLY,
                ScenarioActionType.CHANGE_TICKET_STATUS,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD
            ],
            mustConditions: [
                ScenarioConditionType.COMPANY,
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.TICKET_PRIORITY,
                ScenarioConditionType.TICKET_ASSIGNEE,
                ScenarioConditionType.TICKET_MAILBOX,
                ScenarioConditionType.TICKET_CHANNEL,
                ScenarioConditionType.TICKET_REPLIES_COUNT,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.TICKETS],
            categories: [ScenarioCategory.PRODUCTIVITY],
            notification: {
                notificationType: WebNotificationType.SPOTTER_REDUCE_TICKET_HANDLING_DELAYS,
                dynamicNotificationTypes: ['toTicketAssignedAgentOrGroup', 'toTicketAssignedAgentManager']
            },
            triggerOptionsOverrides: {
                excludedTicketStatuses: [TicketStatus.INVESTIGATING],
                timePeriodType: InlineTimePeriodType.DAYS_HOURS_MINUTES,
            },
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY],
                excludedChannel: [Channel.SMS_INBOUND, Channel.WHATSAPP]
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.AGENT]
            },
            canApplyToSnoozedTickets: true,
        },
        _a[RecipeType.NOTIFY_CUSTOM_FIELD_UPDATED] = {
            scenarioType: RecipeType.NOTIFY_CUSTOM_FIELD_UPDATED,
            actions: [
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.CHANGE_TICKET_STATUS,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.ADD_AGENT_REPLY,
                ScenarioActionType.REASSIGN_TICKET,
                ScenarioActionType.SET_TICKET_PRIORITY,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD,
            ],
            mustConditions: [
                ScenarioConditionType.LABEL,
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.COMPANY,
                ScenarioConditionType.TICKET_PRIORITY,
                ScenarioConditionType.TICKET_STATUS,
                ScenarioConditionType.TICKET_CHANNEL,
                ScenarioConditionType.TICKET_MAILBOX,
                ScenarioConditionType.TICKET_ASSIGNEE,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.TICKETS],
            categories: [ScenarioCategory.OPERATIONS],
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY],
                excludedChannel: [Channel.SMS_INBOUND, Channel.WHATSAPP]
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.AGENT]
            },
            notification: {
                notificationType: WebNotificationType.SPOTTER_NOTIFY_CUSTOM_FIELD_UPDATED,
                dynamicNotificationTypes: ['toTicketAssignedAgentManager', 'toTicketAssignedAgentOrGroup', 'toLastAgentReplier', 'toTicketAgents']
            },
        },
        _a[RecipeType.DETECT_LONG_CALLS] = {
            scenarioType: RecipeType.DETECT_LONG_CALLS,
            actions: [
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD
            ],
            mustConditions: [
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.AGENT_LOCATION,
                ScenarioConditionType.QUEUE,
                ScenarioConditionType.PHONE_CALL_COUNTRY,
                ScenarioConditionType.COMPANY,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.CC],
            categories: [ScenarioCategory.PRODUCTIVITY],
            notification: {
                notificationType: WebNotificationType.SPOTTER_DETECT_LONG_CALLS,
                dynamicNotificationTypes: ['toCallParticipants', 'toCallParticipantsManagers', 'toCallCenterQueueAssignees']
            },
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY, CustomFieldOptionType.AGENT]
            },
            triggerOptionsOverrides: {
                timePeriodType: InlineTimePeriodType.HOURS_MINUTES,
            }
        },
        _a[RecipeType.ALERT_WHEN_PRIORITY_CHANGED] = {
            scenarioType: RecipeType.ALERT_WHEN_PRIORITY_CHANGED,
            actions: [
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.ADD_AGENT_REPLY,
                ScenarioActionType.CHANGE_TICKET_STATUS,
                ScenarioActionType.REASSIGN_TICKET,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD,
            ],
            mustConditions: [
                ScenarioConditionType.TICKET_STATUS,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.TICKET_CHANNEL,
                ScenarioConditionType.TICKET_ASSIGNEE,
                ScenarioConditionType.TICKET_REPLIES_COUNT,
                ScenarioConditionType.COMPANY,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.TICKETS],
            categories: [ScenarioCategory.ATTENTION],
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY],
                excludedChannel: [Channel.SMS_INBOUND, Channel.WHATSAPP]
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.AGENT]
            },
            notification: {
                notificationType: WebNotificationType.SPOTTER_ALERT_WHEN_PRIORITY_CHANGED,
                dynamicNotificationTypes: ['toCompanyAccountManager']
            }
        },
        _a[RecipeType.DETECT_TICKET_PING_PONG] = {
            scenarioType: RecipeType.DETECT_TICKET_PING_PONG,
            actions: [
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.ADD_AGENT_REPLY,
                ScenarioActionType.CHANGE_TICKET_STATUS,
                ScenarioActionType.REASSIGN_TICKET,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD,
            ],
            mustConditions: [
                ScenarioConditionType.TICKET_PRIORITY,
                ScenarioConditionType.COMPANY,
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.TICKET_MAILBOX,
                ScenarioConditionType.TICKET_CHANNEL,
                ScenarioConditionType.TICKET_ASSIGNEE,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.TICKETS],
            categories: [ScenarioCategory.QUALITY_OF_SERVICE, ScenarioCategory.PRODUCTIVITY],
            notification: {
                notificationType: WebNotificationType.SPOTTER_DETECT_TICKET_PING_PONG,
                dynamicNotificationTypes: ['toTicketAssignedAgentOrGroup', 'toTicketAssignedAgentManager'],
            },
            conditionOptionsOverrides: {
                excludedChannel: [Channel.PHONE_CALLBACK, Channel.CHAT, Channel.SMS_INBOUND, Channel.WHATSAPP],
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY]
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.AGENT]
            },
        },
        _a[RecipeType.NOTIFY_ABOUT_UNHAPPY_CUSTOMERS] = {
            scenarioType: RecipeType.NOTIFY_ABOUT_UNHAPPY_CUSTOMERS,
            actions: [
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.ADD_AGENT_REPLY,
                ScenarioActionType.CHANGE_TICKET_STATUS,
                ScenarioActionType.REASSIGN_TICKET,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD,
            ],
            mustConditions: [
                ScenarioConditionType.TICKET_PRIORITY,
                ScenarioConditionType.TICKET_MAILBOX,
                ScenarioConditionType.TICKET_CHANNEL,
                ScenarioConditionType.COMPANY,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.TICKETS],
            categories: [ScenarioCategory.QUALITY_OF_SERVICE, ScenarioCategory.ATTENTION],
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY],
                excludedChannel: [Channel.SMS_INBOUND, Channel.WHATSAPP]
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.AGENT]
            },
            notification: {
                notificationType: WebNotificationType.SPOTTER_NOTIFY_ABOUT_UNHAPPY_CUSTOMERS,
                dynamicNotificationTypes: ['toRelevantAgent', 'toRelevantAgentManager', 'toCompanyAccountManager']
            }
        },
        _a[RecipeType.KEEP_ARTICLES_UP_TO_DATE] = {
            scenarioType: RecipeType.KEEP_ARTICLES_UP_TO_DATE,
            actions: [
                ScenarioActionType.CREATE_ARTICLE_TASK,
                ScenarioActionType.SEND_NOTIFICATION,
            ],
            mustConditions: [],
            modules: [ScenarioModule.KB],
            categories: [ScenarioCategory.QUALITY_OF_SERVICE],
            notification: {
                notificationType: WebNotificationType.SPOTTER_KEEP_ARTICLES_UP_TO_DATE,
                dynamicNotificationTypes: ['toArticleAuthor', 'toArticleAuthorManager']
            }
        },
        _a[RecipeType.TICKET_HAS_NOT_BEEN_ANSWERED] = {
            scenarioType: RecipeType.TICKET_HAS_NOT_BEEN_ANSWERED,
            actions: [
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.ADD_AGENT_REPLY,
                ScenarioActionType.CHANGE_TICKET_STATUS,
                ScenarioActionType.REASSIGN_TICKET,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD,
            ],
            mustConditions: [
                ScenarioConditionType.COMPANY,
                ScenarioConditionType.TICKET_MAILBOX,
                ScenarioConditionType.TICKET_PRIORITY,
                ScenarioConditionType.TICKET_CHANNEL,
                ScenarioConditionType.TICKET_ASSIGNEE,
                ScenarioConditionType.TICKET_REPLIES_COUNT,
                ScenarioConditionType.TICKET_STATUS,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.TICKETS],
            categories: [ScenarioCategory.ATTENTION],
            notification: {
                notificationType: WebNotificationType.SPOTTER_TICKET_NOT_ANSWERED,
                dynamicNotificationTypes: ['toTicketAssignedAgentOrGroup', 'toTicketAssignedAgentManager', 'toCompanyAccountManager']
            },
            triggerOptionsOverrides: {
                timePeriodType: InlineTimePeriodType.DAYS_HOURS_MINUTES,
            },
            conditionOptionsOverrides: {
                excludedChannel: [Channel.PHONE_CALLBACK, Channel.CHAT, Channel.FACEBOOK, Channel.SMS_INBOUND, Channel.WHATSAPP],
                excludedTicketStatuses: [TicketStatus.CLOSED, TicketStatus.SOLVED],
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY]
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.AGENT]
            },
            canApplyToSnoozedTickets: true
        },
        _a[RecipeType.ESCALATE_STUCK_TICKETS] = {
            scenarioType: RecipeType.ESCALATE_STUCK_TICKETS,
            actions: [
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.ADD_AGENT_REPLY,
                ScenarioActionType.CHANGE_TICKET_STATUS,
                ScenarioActionType.REASSIGN_TICKET,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD
            ],
            mustConditions: [
                ScenarioConditionType.COMPANY,
                ScenarioConditionType.TICKET_PRIORITY,
                ScenarioConditionType.TICKET_ASSIGNEE,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.TICKET_MAILBOX,
                ScenarioConditionType.TICKET_CHANNEL,
                ScenarioConditionType.TICKET_REPLIES_COUNT,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.TICKETS, ScenarioModule.TEAM_MEMBERS],
            categories: [ScenarioCategory.QUALITY_OF_SERVICE, ScenarioCategory.PRODUCTIVITY],
            notification: {
                notificationType: WebNotificationType.SPOTTER_ESCALATE_STUCK_TICKETS,
                dynamicNotificationTypes: ['toTicketAssignedAgentOrGroup', 'toTicketAssignedAgentManager']
            },
            triggerOptionsOverrides: {
                timePeriodType: InlineTimePeriodType.DAYS_HOURS_MINUTES,
            },
            disabledConditionOperators: (_b = {},
                _b[ScenarioConditionType.TICKET_ASSIGNEE] = [ScenarioOperator.IS_SET, ScenarioOperator.NOT_SET],
                _b),
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY, CustomFieldOptionType.AGENT]
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.AGENT]
            },
            canApplyToSnoozedTickets: true,
        },
        _a[RecipeType.AUTOMATE_ABANDONED_CHAT_RESOLUTION] = {
            scenarioType: RecipeType.AUTOMATE_ABANDONED_CHAT_RESOLUTION,
            actions: [
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.SEND_CHAT_AUTO_REPLY,
                ScenarioActionType.CHANGE_TICKET_STATUS,
                ScenarioActionType.END_ALL_HANDLING,
                ScenarioActionType.END_CHAT,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD
            ],
            mustConditions: [
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.CHAT_WIDGET,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.CHAT],
            categories: [ScenarioCategory.OPERATIONS],
            notification: {
                notificationType: WebNotificationType.SPOTTER_ABANDONED_CHAT_RESOLUTION,
                dynamicNotificationTypes: ['toChatParticipants', 'toChatParticipantsManagers']
            },
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY]
            },
            triggerOptionsOverrides: {
                timePeriodType: InlineTimePeriodType.HOURS_MINUTES,
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.AGENT]
            }
        },
        _a[RecipeType.REDUCE_CALLBACK_WAIT_TIME] = {
            scenarioType: RecipeType.REDUCE_CALLBACK_WAIT_TIME,
            actions: [
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.ADD_AGENT_REPLY,
                ScenarioActionType.CHANGE_TICKET_STATUS,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD,
                ScenarioActionType.CHANGE_PRIORITY_SCORE,
            ],
            mustConditions: [
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.QUEUE,
                ScenarioConditionType.PHONE_CALL_COUNTRY,
                ScenarioConditionType.COMPANY,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.CC],
            categories: [ScenarioCategory.PRODUCTIVITY],
            notification: {
                notificationType: WebNotificationType.SPOTTER_REDUCE_CALLBACK_WAIT_TIME,
                dynamicNotificationTypes: ['toCallCenterQueueAssignees']
            },
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY]
            },
            triggerOptionsOverrides: {
                timePeriodType: InlineTimePeriodType.DAYS_HOURS_MINUTES,
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.AGENT]
            }
        },
        _a[RecipeType.AUTOMATE_AGENT_RESPONSE_IN_CHAT] = {
            scenarioType: RecipeType.AUTOMATE_AGENT_RESPONSE_IN_CHAT,
            actions: [
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.SEND_CHAT_AUTO_REPLY,
                ScenarioActionType.CHANGE_TICKET_STATUS,
                ScenarioActionType.END_ALL_HANDLING,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.END_CHAT,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD
            ],
            mustConditions: [
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.CHAT_WIDGET,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.CHAT],
            categories: [ScenarioCategory.OPERATIONS],
            notification: {
                notificationType: WebNotificationType.SPOTTER_AUTOMATE_AGENT_RESPONSE_IN_CHAT,
                dynamicNotificationTypes: ['toChatParticipants', 'toChatParticipantsManagers']
            },
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY, CustomFieldOptionType.AGENT]
            },
            triggerOptionsOverrides: {
                timePeriodType: InlineTimePeriodType.HOURS_MINUTES,
            }
        },
        _a[RecipeType.TICKET_ASSIGNED_TO_AGENT_ON_LEAVE] = {
            scenarioType: RecipeType.TICKET_ASSIGNED_TO_AGENT_ON_LEAVE,
            actions: [
                ScenarioActionType.UNASSIGN_TICKET,
                ScenarioActionType.CHANGE_TICKET_STATUS,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.REASSIGN_TICKET,
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD,
            ],
            mustConditions: [
                ScenarioConditionType.AGENT_LOCATION,
                ScenarioConditionType.AGENT_GROUP,
                ScenarioConditionType.AGENT_ROLE,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.TEAM_MEMBERS, ScenarioModule.TICKETS],
            categories: [ScenarioCategory.OPERATIONS],
            notification: {
                notificationType: WebNotificationType.SPOTTER_TICKET_ASSIGNED_TO_AGENT_ON_LEAVE,
                dynamicNotificationTypes: ['toRelevantAgentManager', 'toCompanyAccountManager']
            },
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY, CustomFieldOptionType.AGENT]
            },
            defaultActions: [ScenarioActionType.UNASSIGN_TICKET, ScenarioActionType.SEND_NOTIFICATION]
        },
        _a[RecipeType.MONITOR_CALL_CENTER_PRODUCTIVITY] = {
            scenarioType: RecipeType.MONITOR_CALL_CENTER_PRODUCTIVITY,
            actions: [
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.SEND_NOTIFICATION,
            ],
            mustConditions: [
                ScenarioConditionType.AGENT_ROLE,
                ScenarioConditionType.AGENT_LOCATION,
                ScenarioConditionType.AGENT_GROUP,
                ScenarioConditionType.QUEUE,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.TEAM_MEMBERS, ScenarioModule.CC],
            categories: [ScenarioCategory.PRODUCTIVITY],
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.AGENT]
            },
            notification: {
                notificationType: WebNotificationType.SPOTTER_MONITOR_CALL_CENTER_PRODUCTIVITY,
                dynamicNotificationTypes: ['toRelevantAgent', 'toRelevantAgentManager']
            }
        },
        _a[RecipeType.REDUCE_INBOUND_CALLS_WAIT_TIME] = {
            scenarioType: RecipeType.REDUCE_INBOUND_CALLS_WAIT_TIME,
            actions: [
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.ADD_AGENT_REPLY,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD,
                ScenarioActionType.CHANGE_PRIORITY_SCORE,
            ],
            mustConditions: [
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.PHONE_CALL_COUNTRY,
                ScenarioConditionType.QUEUE,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.COMPANY,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.CC],
            categories: [ScenarioCategory.PRODUCTIVITY],
            notification: {
                notificationType: WebNotificationType.SPOTTER_REDUCE_INBOUND_CALLS_WAIT_TIME,
                dynamicNotificationTypes: ['toCallCenterQueueAssignees']
            },
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY]
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.AGENT, CustomFieldOptionType.TICKET]
            },
            triggerOptionsOverrides: {
                timePeriodType: InlineTimePeriodType.HOURS_MINUTES
            }
        },
        _a[RecipeType.TAG_INCOMPLETE_CALLS] = {
            scenarioType: RecipeType.TAG_INCOMPLETE_CALLS,
            actions: [
                ScenarioActionType.CHANGE_TICKET_STATUS,
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.ADD_AGENT_REPLY,
                ScenarioActionType.REASSIGN_TICKET,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD,
            ],
            mustConditions: [
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.PHONE_CALL_COUNTRY,
                ScenarioConditionType.COMPANY,
                ScenarioConditionType.QUEUE,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.CC],
            categories: [ScenarioCategory.QUALITY_OF_SERVICE, ScenarioCategory.OPERATIONS],
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY]
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.AGENT]
            },
            notification: {
                notificationType: WebNotificationType.SPOTTER_TAG_INCOMPLETE_CALLS,
                dynamicNotificationTypes: ['toCallParticipants', 'toCallParticipantsManagers']
            }
        },
        _a[RecipeType.HANDLE_VOICEMAIL_MESSAGES] = {
            scenarioType: RecipeType.HANDLE_VOICEMAIL_MESSAGES,
            actions: [
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.ADD_AGENT_REPLY,
                ScenarioActionType.CHANGE_TICKET_STATUS,
                ScenarioActionType.REASSIGN_TICKET,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.SET_TICKET_PRIORITY,
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD,
            ],
            mustConditions: [
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.QUEUE,
                ScenarioConditionType.COMPANY,
                ScenarioConditionType.LINE,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.CC],
            categories: [ScenarioCategory.OPERATIONS],
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY]
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.AGENT]
            },
            notification: {
                notificationType: WebNotificationType.SPOTTER_HANDLE_VOICEMAIL_MESSAGES,
                dynamicNotificationTypes: ['toCallCenterQueueAssignees']
            }
        },
        _a[RecipeType.ALERT_CALL_CENTER_WORKLOAD] = {
            scenarioType: RecipeType.ALERT_CALL_CENTER_WORKLOAD,
            actions: [
                ScenarioActionType.SEND_NOTIFICATION,
            ],
            mustConditions: [
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.PHONE_CALL_COUNTRY,
                ScenarioConditionType.QUEUE,
                ScenarioConditionType.COMPANY,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.CC],
            categories: [ScenarioCategory.PRODUCTIVITY, ScenarioCategory.ATTENTION],
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY]
            },
            notification: {
                notificationType: WebNotificationType.SPOTTER_ALERT_CALL_CENTER_WORKLOAD,
                dynamicNotificationTypes: []
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.AGENT]
            },
        },
        _a[RecipeType.MONITOR_AGENT_CALL_CENTER_STATUS] = {
            scenarioType: RecipeType.MONITOR_AGENT_CALL_CENTER_STATUS,
            actions: [
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.SET_AGENT_STATUS,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD,
            ],
            mustConditions: [
                ScenarioConditionType.AGENT_GROUP,
                ScenarioConditionType.QUEUE,
                ScenarioConditionType.AGENT_LOCATION,
                ScenarioConditionType.AGENT_ROLE,
                ScenarioConditionType.AGENT_STATUS,
                ScenarioConditionType.AGENT_ASSIGNED_CHANNEL,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: __spreadArrays([
                ScenarioModule.TEAM_MEMBERS
            ], (!isFeatureEnabled('SpotterScenario19GlobalStatuses') ? [ScenarioModule.CC] : [])),
            categories: [ScenarioCategory.PRODUCTIVITY],
            notification: {
                notificationType: WebNotificationType.SPOTTER_MONITOR_AGENT_CALL_CENTER_STATUS,
                dynamicNotificationTypes: ['toRelevantAgent', 'toRelevantAgentManager']
            },
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.AGENT],
            },
            triggerOptionsOverrides: {
                timePeriodType: InlineTimePeriodType.DAYS_HOURS_MINUTES,
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.TICKET, CustomFieldOptionType.COMPANY, CustomFieldOptionType.USER]
            },
            mandatoryConditions: __spreadArrays((isFeatureEnabled('SpotterScenario19GlobalStatuses') ? [ScenarioConditionType.AGENT_STATUS] : [])),
        },
        _a[RecipeType.HANDLE_TICKETS_ASSIGNED_TO_DELETED_AGENT] = {
            scenarioType: RecipeType.HANDLE_TICKETS_ASSIGNED_TO_DELETED_AGENT,
            actions: [
                ScenarioActionType.UNASSIGN_TICKET,
                ScenarioActionType.REASSIGN_TICKET,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD,
            ],
            mustConditions: [
                ScenarioConditionType.AGENT_ROLE,
                ScenarioConditionType.AGENT_LOCATION,
                ScenarioConditionType.AGENT_GROUP,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.TEAM_MEMBERS, ScenarioModule.TICKETS],
            categories: [ScenarioCategory.OPERATIONS],
            notification: {
                notificationType: WebNotificationType.SPOTTER_HANDLE_TICKETS_ASSIGNED_TO_DELETED_AGENT,
                dynamicNotificationTypes: ['toRelevantAgentManager']
            },
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.AGENT]
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.AGENT, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY]
            },
            isMultipleTicketsScenario: true,
            defaultActions: [ScenarioActionType.UNASSIGN_TICKET, ScenarioActionType.SEND_NOTIFICATION]
        },
        _a[RecipeType.HANDLE_UNANSWERED_CALLBACKS] = {
            scenarioType: RecipeType.HANDLE_UNANSWERED_CALLBACKS,
            actions: [
                ScenarioActionType.CREATE_CALLBACK,
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.ADD_AGENT_REPLY,
                ScenarioActionType.CHANGE_TICKET_STATUS,
                ScenarioActionType.REASSIGN_TICKET,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD,
            ],
            mustConditions: [
                ScenarioConditionType.TICKET_ASSIGNEE,
                ScenarioConditionType.COMPANY,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.LINE,
                ScenarioConditionType.TICKET_PRIORITY,
                ScenarioConditionType.QUEUE,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.CC],
            categories: [ScenarioCategory.OPERATIONS],
            notification: {
                notificationType: WebNotificationType.SPOTTER_HANDLE_UNANSWERED_CALLBACKS,
                dynamicNotificationTypes: ['toCallParticipants', 'toCallParticipantsManagers', 'toCallCenterQueueAssignees']
            }, triggerOptionsOverrides: {
                timePeriodType: InlineTimePeriodType.DAYS_HOURS_MINUTES,
                excludedCallStatuses: [ExtendedCallStatus.BUSY, ExtendedCallStatus.HUNG_UP_IN_IVR, ExtendedCallStatus.HUNG_UP_IN_QUEUE]
            },
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY]
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.AGENT]
            },
            defaultActions: [ScenarioActionType.CREATE_CALLBACK]
        },
        _a[RecipeType.AGENT_LINKING_KPI] = {
            scenarioType: RecipeType.AGENT_LINKING_KPI,
            actions: [
                ScenarioActionType.SEND_NOTIFICATION,
            ],
            mustConditions: [
                ScenarioConditionType.AGENT_ROLE,
                ScenarioConditionType.AGENT_LOCATION,
                ScenarioConditionType.AGENT_GROUP,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.TEAM_MEMBERS, ScenarioModule.TICKETS],
            categories: [ScenarioCategory.PRODUCTIVITY],
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.AGENT]
            },
            notification: {
                notificationType: WebNotificationType.SPOTTER_AGENT_LINKING_KPI,
                dynamicNotificationTypes: ['toRelevantAgent', 'toRelevantAgentManager']
            }
        },
        _a[RecipeType.OPTIMIZE_LINKING_TICKETS_WITH_ARTICLES] = {
            scenarioType: RecipeType.OPTIMIZE_LINKING_TICKETS_WITH_ARTICLES,
            actions: [
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.CHANGE_TICKET_STATUS,
                ScenarioActionType.REASSIGN_TICKET,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.SEND_NOTIFICATION,
            ],
            mustConditions: [
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.TICKET_CHANNEL,
            ],
            modules: [ScenarioModule.TICKETS],
            categories: [ScenarioCategory.PRODUCTIVITY],
            notification: {
                notificationType: WebNotificationType.SPOTTER_OPTIMIZE_LINKING_TICKETS_WITH_ARTICLES,
                dynamicNotificationTypes: ['toTicketAssignedAgentOrGroup', 'toTicketAssignedAgentManager']
            },
            conditionOptionsOverrides: {
                excludedChannel: [Channel.SMS_INBOUND, Channel.WHATSAPP]
            }
        },
        _a[RecipeType.AGENT_TRANSFER_COUNTER] = {
            scenarioType: RecipeType.AGENT_TRANSFER_COUNTER,
            actions: [
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD,
            ],
            mustConditions: [
                ScenarioConditionType.AGENT_ROLE,
                ScenarioConditionType.AGENT_LOCATION,
                ScenarioConditionType.AGENT_GROUP,
                ScenarioConditionType.QUEUE,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.TEAM_MEMBERS, ScenarioModule.CC],
            categories: [ScenarioCategory.QUALITY_OF_SERVICE, ScenarioCategory.PRODUCTIVITY],
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.AGENT]
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [
                    CustomFieldOptionType.COMPANY,
                    CustomFieldOptionType.TICKET,
                    CustomFieldOptionType.USER
                ]
            },
            notification: {
                notificationType: WebNotificationType.SPOTTER_AGENT_TRANSFER_COUNTER,
                dynamicNotificationTypes: ['toRelevantAgent', 'toRelevantAgentManager']
            }
        },
        _a[RecipeType.ALERT_OPEN_TICKETS_VOLUME] = {
            scenarioType: RecipeType.ALERT_OPEN_TICKETS_VOLUME,
            actions: [ScenarioActionType.SEND_NOTIFICATION],
            mustConditions: [
                ScenarioConditionType.TICKET_PRIORITY,
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.TICKET_REPLIES_COUNT,
                ScenarioConditionType.TICKET_MAILBOX,
                ScenarioConditionType.TICKET_CHANNEL,
                ScenarioConditionType.TICKET_ASSIGNEE,
                ScenarioConditionType.COMPANY,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
                ScenarioConditionType.TICKET_SESSION_STATUS
            ],
            modules: [ScenarioModule.TICKETS],
            categories: [ScenarioCategory.PRODUCTIVITY, ScenarioCategory.ATTENTION],
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY],
                excludedChannel: [Channel.SMS_INBOUND, Channel.WHATSAPP]
            },
            notification: {
                notificationType: WebNotificationType.SPOTTER_ALERT_OPEN_TICKETS_VOLUME,
                dynamicNotificationTypes: []
            }
        },
        _a[RecipeType.REDUCE_CHAT_WAIT_TIME] = {
            scenarioType: RecipeType.REDUCE_CHAT_WAIT_TIME,
            actions: [ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.SEND_CHAT_AUTO_REPLY,
                ScenarioActionType.CHANGE_TICKET_STATUS,
                ScenarioActionType.REASSIGN_TICKET,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD,
            ],
            mustConditions: [
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.CHAT_WIDGET,
                ScenarioConditionType.TICKET_ASSIGNEE,
                ScenarioConditionType.TICKET_PRIORITY,
                ScenarioConditionType.COMPANY,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.CHAT],
            triggerOptionsOverrides: {
                timePeriodType: InlineTimePeriodType.HOURS_MINUTES
            },
            categories: [ScenarioCategory.OPERATIONS, ScenarioCategory.ATTENTION],
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY]
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.AGENT]
            },
            notification: {
                notificationType: WebNotificationType.SPOTTER_REDUCE_CHAT_WAIT_TIME,
                dynamicNotificationTypes: []
            }
        },
        _a[RecipeType.ALERT_COMPANIES_TICKET_VOLUME] = {
            scenarioType: RecipeType.ALERT_COMPANIES_TICKET_VOLUME,
            actions: [
                ScenarioActionType.SEND_NOTIFICATION,
            ],
            mustConditions: [
                ScenarioConditionType.TICKET_PRIORITY,
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.TICKET_MAILBOX,
                ScenarioConditionType.TICKET_CHANNEL,
                ScenarioConditionType.TICKET_REPLIES_COUNT,
                ScenarioConditionType.TICKET_ASSIGNEE,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.TICKETS],
            categories: [ScenarioCategory.ATTENTION],
            notification: {
                notificationType: WebNotificationType.SPOTTER_ALERT_COMPANIES_TICKET_VOLUME,
                dynamicNotificationTypes: ['toCompanyAccountManager'],
            },
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY],
                excludedChannel: [Channel.SMS_INBOUND, Channel.WHATSAPP]
            },
            triggerOptionsOverrides: {
                excludedTicketStatuses: [TicketStatus.CLOSED, TicketStatus.SOLVED],
            }
        },
        _a[RecipeType.DELETE_OUTDATED_CALL_RECORDINGS] = {
            scenarioType: RecipeType.DELETE_OUTDATED_CALL_RECORDINGS,
            actions: [
                ScenarioActionType.DELETE_CALL_RECORDING,
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.ADD_AGENT_REPLY,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD,
            ],
            mustConditions: [
                ScenarioConditionType.LINE,
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.QUEUE,
                ScenarioConditionType.COMPANY,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.CC],
            categories: [ScenarioCategory.OPERATIONS],
            notification: {
                notificationType: WebNotificationType.SPOTTER_DELETE_OUTDATED_CALL_RECORDINGS,
                dynamicNotificationTypes: [],
            },
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY]
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.AGENT]
            },
            triggerOptionsOverrides: {
                timePeriodType: InlineTimePeriodType.DAYS_HOURS_MINUTES,
            },
            defaultActions: [ScenarioActionType.DELETE_CALL_RECORDING],
        },
        _a[RecipeType.MONITOR_AGENT_SESSIONS] = {
            scenarioType: RecipeType.MONITOR_AGENT_SESSIONS,
            actions: [
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.REASSIGN_TICKET,
                ScenarioActionType.CHANGE_TICKET_STATUS,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD,
                ScenarioActionType.END_HANDLING,
            ],
            mustConditions: [
                ScenarioConditionType.AGENT_LOCATION,
                ScenarioConditionType.AGENT_GROUP,
                ScenarioConditionType.AGENT_ROLE,
                ScenarioConditionType.AGENT_ASSIGNED_CHANNEL,
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.TICKET_PRIORITY,
                ScenarioConditionType.TICKET_CHANNEL,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.TICKET_MAILBOX,
                ScenarioConditionType.TICKET_ASSIGNEE,
                ScenarioConditionType.TICKET_REPLIES_COUNT,
                ScenarioConditionType.COMPANY,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.TEAM_MEMBERS, ScenarioModule.TICKETS],
            categories: [ScenarioCategory.PRODUCTIVITY],
            notification: {
                notificationType: WebNotificationType.SPOTTER_MONITOR_AGENT_SESSIONS,
                dynamicNotificationTypes: ['toRelevantAgent', 'toRelevantAgentManager', 'toTicketAssignedAgentOrGroup', 'toTicketAssignedAgentManager'],
            },
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.AGENT, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY],
                excludedChannel: [Channel.SMS_INBOUND, Channel.WHATSAPP]
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.AGENT, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY]
            },
            triggerOptionsOverrides: {
                timePeriodType: InlineTimePeriodType.DAYS_HOURS_MINUTES,
            },
            defaultActions: [ScenarioActionType.END_HANDLING],
        },
        _a[RecipeType.NOTIFY_TICKET_ASSIGNED_TO_AGENT_OR_GROUP] = {
            scenarioType: RecipeType.NOTIFY_TICKET_ASSIGNED_TO_AGENT_OR_GROUP,
            actions: [
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.CHANGE_TICKET_STATUS,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.ADD_AGENT_REPLY,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD,
            ],
            mustConditions: [
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.TICKET_PRIORITY,
                ScenarioConditionType.TICKET_STATUS,
                ScenarioConditionType.TICKET_CHANNEL,
                ScenarioConditionType.TICKET_MAILBOX,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.TICKETS],
            categories: [ScenarioCategory.OPERATIONS],
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY],
                excludedChannel: [Channel.SMS_INBOUND, Channel.WHATSAPP]
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.AGENT]
            },
            notification: {
                notificationType: WebNotificationType.SPOTTER_NOTIFY_TICKET_ASSIGNED_TO_AGENT_OR_GROUP,
                dynamicNotificationTypes: ['toCompanyAccountManager', 'toLastAgentReplier', 'toTicketAssignedAgentOrGroup', 'toTicketAgents'],
            },
        },
        _a[RecipeType.MONITOR_AGENT_CHAT_TRANSFERS] = {
            scenarioType: RecipeType.MONITOR_AGENT_CHAT_TRANSFERS,
            actions: [
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD,
            ],
            mustConditions: [
                ScenarioConditionType.AGENT_GROUP,
                ScenarioConditionType.AGENT_LOCATION,
                ScenarioConditionType.AGENT_ROLE,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.TEAM_MEMBERS, ScenarioModule.CHAT],
            categories: [ScenarioCategory.QUALITY_OF_SERVICE, ScenarioCategory.PRODUCTIVITY],
            triggerOptionsOverrides: {
                timePeriodType: InlineTimePeriodType.DAYS_HOURS,
            },
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.AGENT],
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.USER, CustomFieldOptionType.TICKET, CustomFieldOptionType.COMPANY]
            },
            notification: {
                notificationType: WebNotificationType.SPOTTER_MONITOR_AGENT_CHAT_TRANSFERS,
                dynamicNotificationTypes: ['toRelevantAgent', 'toRelevantAgentManager'],
            },
        },
        _a[RecipeType.REDUCE_TRANSFERRED_CALL_WAIT_TIME] = {
            scenarioType: RecipeType.REDUCE_TRANSFERRED_CALL_WAIT_TIME,
            actions: [
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.ADD_AGENT_REPLY,
                ScenarioActionType.CHANGE_TICKET_STATUS,
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.CHANGE_PRIORITY_SCORE,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD,
            ],
            mustConditions: [
                ScenarioConditionType.PHONE_CALL_COUNTRY,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.QUEUE,
                ScenarioConditionType.COMPANY,
                ScenarioConditionType.PHONE_CALL_TYPE,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD
            ],
            modules: [ScenarioModule.CC],
            categories: [ScenarioCategory.PRODUCTIVITY],
            triggerOptionsOverrides: {
                timePeriodType: InlineTimePeriodType.DAYS_HOURS_MINUTES,
            },
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY]
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.AGENT]
            },
            notification: {
                notificationType: WebNotificationType.SPOTTER_REDUCE_TRANSFERRED_CALL_WAIT_TIME,
                dynamicNotificationTypes: ['toCallCenterQueueAssignees', 'toRelevantAgentManager', 'toTicketAssignedAgentOrGroup', 'toTicketAssignedAgentManager'],
            },
        },
        _a[RecipeType.REDUCE_TRANSFERRED_CHAT_WAIT_TIME] = {
            scenarioType: RecipeType.REDUCE_TRANSFERRED_CHAT_WAIT_TIME,
            actions: [
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.ADD_AGENT_REPLY,
                ScenarioActionType.CHANGE_TICKET_STATUS,
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD,
            ],
            mustConditions: [
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.CHAT_WIDGET,
                ScenarioConditionType.TICKET_ASSIGNEE,
                ScenarioConditionType.TICKET_PRIORITY,
                ScenarioConditionType.COMPANY,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD
            ],
            modules: [ScenarioModule.CHAT],
            categories: [ScenarioCategory.PRODUCTIVITY],
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY]
            },
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.AGENT]
            },
            triggerOptionsOverrides: {
                timePeriodType: InlineTimePeriodType.DAYS_HOURS_MINUTES,
            },
            notification: {
                notificationType: WebNotificationType.SPOTTER_REDUCE_TRANSFERRED_CHAT_WAIT_TIME,
                dynamicNotificationTypes: ['toChatParticipants', 'toTicketAssignedAgentOrGroup', 'toTicketAssignedAgentManager'],
            },
        },
        _a[RecipeType.CALL_TRANSFERRED] = {
            scenarioType: RecipeType.CALL_TRANSFERRED,
            actions: [
                ScenarioActionType.SET_PRIORITY_SCORE,
                ScenarioActionType.CHANGE_PRIORITY_SCORE,
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.REASSIGN_TICKET,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.ADD_AGENT_REPLY,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD
            ],
            mustConditions: [
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.TICKET_ASSIGNEE,
                ScenarioConditionType.LINE,
                ScenarioConditionType.QUEUE,
                ScenarioConditionType.PHONE_CALL_TYPE,
                ScenarioConditionType.COMPANY,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            modules: [ScenarioModule.CC, ScenarioModule.TICKET_SCORING],
            categories: [ScenarioCategory.PRODUCTIVITY, ScenarioCategory.OPERATIONS],
            notification: {
                notificationType: WebNotificationType.SPOTTER_CALL_TRANSFERRED,
                dynamicNotificationTypes: []
            },
            triggerOptionsOverrides: {},
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY]
            },
            defaultActions: [ScenarioActionType.SET_PRIORITY_SCORE],
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.AGENT]
            }
        },
        _a[RecipeType.TICKET_CREATED] = {
            scenarioType: RecipeType.TICKET_CREATED,
            actions: [
                ScenarioActionType.SET_PRIORITY_SCORE,
                ScenarioActionType.CHANGE_PRIORITY_SCORE,
                ScenarioActionType.SEND_NOTIFICATION,
                ScenarioActionType.ADD_INTERNAL_NOTE,
                ScenarioActionType.ADD_AGENT_REPLY,
                ScenarioActionType.SET_TICKET_LABELS,
                ScenarioActionType.REASSIGN_TICKET,
                ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD
            ],
            mustConditions: [
                ScenarioConditionType.LOCALE,
                ScenarioConditionType.LABEL,
                ScenarioConditionType.TICKET_ASSIGNEE,
                ScenarioConditionType.LINE,
                ScenarioConditionType.QUEUE,
                ScenarioConditionType.COMPANY,
                ScenarioConditionType.PHONE_CALL_TYPE,
                ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            ],
            mandatoryConditions: [ScenarioConditionType.PHONE_CALL_TYPE],
            modules: [ScenarioModule.CC, ScenarioModule.TICKET_SCORING],
            categories: [ScenarioCategory.PRODUCTIVITY, ScenarioCategory.OPERATIONS],
            notification: {
                notificationType: WebNotificationType.SPOTTER_TICKET_CREATED,
                dynamicNotificationTypes: []
            },
            conditionOptionsOverrides: {
                customFieldOption: [CustomFieldOptionType.TICKET, CustomFieldOptionType.USER, CustomFieldOptionType.COMPANY],
                excludedCallTypes: [CallType.OUTBOUND]
            },
            defaultActions: [ScenarioActionType.SET_PRIORITY_SCORE],
            actionOptionsOverrides: {
                excludedCustomFieldTypes: [CustomFieldOptionType.AGENT]
            },
            disabledConditionOperators: (_c = {}, _c[ScenarioConditionType.PHONE_CALL_TYPE] = [ScenarioOperator.NONE_OF], _c)
        },
        _a);
    return scenarioDefinitionMap[recipeType];
};
export var scenarioTriggerMap = (_a = {},
    _a[RecipeType.TICKET_PENDING] = timePeriodTrigger,
    _a[RecipeType.FIX_UNHELPFUL_ARTICLES] = __assign(__assign({}, timePeriodTrigger), numberTrigger),
    _a[RecipeType.REDUCE_TICKET_HANDLING_DELAYS] = timePeriodTrigger,
    _a[RecipeType.DETECT_LONG_CALLS] = timePeriodTrigger,
    _a[RecipeType.ALERT_WHEN_PRIORITY_CHANGED] = priorityChangeTrigger,
    _a[RecipeType.DETECT_TICKET_PING_PONG] = numberTrigger,
    _a[RecipeType.NOTIFY_ABOUT_UNHAPPY_CUSTOMERS] = __assign({}, csatTrigger),
    _a[RecipeType.KEEP_ARTICLES_UP_TO_DATE] = __assign(__assign({}, articleTrigger), timePeriodTrigger),
    _a[RecipeType.TICKET_HAS_NOT_BEEN_ANSWERED] = __assign(__assign({}, replyTypesTrigger), timePeriodTrigger),
    _a[RecipeType.ESCALATE_STUCK_TICKETS] = __assign(__assign({}, ticketStatusTrigger), timePeriodTrigger),
    _a[RecipeType.AUTOMATE_ABANDONED_CHAT_RESOLUTION] = timePeriodTrigger,
    _a[RecipeType.REDUCE_CALLBACK_WAIT_TIME] = timePeriodTrigger,
    _a[RecipeType.AUTOMATE_AGENT_RESPONSE_IN_CHAT] = timePeriodTrigger,
    _a[RecipeType.TICKET_ASSIGNED_TO_AGENT_ON_LEAVE] = emptyTrigger,
    _a[RecipeType.MONITOR_CALL_CENTER_PRODUCTIVITY] = __assign(__assign({}, timePeriodTrigger), numberTrigger),
    _a[RecipeType.REDUCE_INBOUND_CALLS_WAIT_TIME] = timePeriodTrigger,
    _a[RecipeType.TAG_INCOMPLETE_CALLS] = callStatusTrigger,
    _a[RecipeType.HANDLE_VOICEMAIL_MESSAGES] = emptyTrigger,
    _a[RecipeType.ALERT_CALL_CENTER_WORKLOAD] = __assign(__assign(__assign({}, numberTrigger), callStatusGroupTrigger), timePeriodTrigger),
    _a[RecipeType.MONITOR_AGENT_CALL_CENTER_STATUS] = __assign(__assign({}, agentStatusTrigger), timePeriodTrigger),
    _a[RecipeType.HANDLE_TICKETS_ASSIGNED_TO_DELETED_AGENT] = emptyTrigger,
    _a[RecipeType.HANDLE_UNANSWERED_CALLBACKS] = __assign(__assign({}, callStatusTrigger), timePeriodTrigger),
    _a[RecipeType.OPTIMIZE_LINKING_TICKETS_WITH_ARTICLES] = emptyTrigger,
    _a[RecipeType.ALERT_OPEN_TICKETS_VOLUME] = __assign(__assign({}, numberTrigger), timePeriodTrigger),
    _a[RecipeType.ALERT_COMPANIES_TICKET_VOLUME] = __assign(__assign({}, numberTrigger), ticketStatusTrigger),
    _a[RecipeType.REDUCE_CHAT_WAIT_TIME] = __assign({}, timePeriodTrigger),
    _a[RecipeType.AGENT_LINKING_KPI] = __assign(__assign({}, percentTrigger), timePeriodTrigger),
    _a[RecipeType.AGENT_TRANSFER_COUNTER] = __assign(__assign({}, timePeriodTrigger), numberTrigger),
    _a[RecipeType.REMOVE_IRRELEVANT_KNOWN_ISSUES] = __assign({}, timePeriodTrigger),
    _a[RecipeType.NOTIFY_TICKET_ASSIGNED_TO_AGENT_OR_GROUP] = __assign({}, participantsTrigger),
    _a[RecipeType.NOTIFY_CUSTOM_FIELD_UPDATED] = __assign({}, customFieldTrigger),
    _a[RecipeType.MONITOR_AGENT_CHAT_TRANSFERS] = __assign(__assign({}, numberTrigger), timePeriodTrigger),
    _a[RecipeType.REDUCE_TRANSFERRED_CALL_WAIT_TIME] = __assign({}, timePeriodTrigger),
    _a[RecipeType.REDUCE_TRANSFERRED_CHAT_WAIT_TIME] = __assign({}, timePeriodTrigger),
    _a[RecipeType.DELETE_OUTDATED_CALL_RECORDINGS] = __assign({}, timePeriodTrigger),
    _a[RecipeType.MONITOR_AGENT_SESSIONS] = __assign({}, timePeriodTrigger),
    _a[RecipeType.CALL_TRANSFERRED] = emptyTrigger,
    _a[RecipeType.TICKET_CREATED] = callChannelTrigger,
    _a);
export * from "./actions";
export * from "./conditions";
export * from "./triggers";
export * from "./builders";
export * from "./constants";
export * from "./conditions.builders";
export * from "./actions.builders";
export * from "./reply-type.enum";
//# sourceMappingURL=index.js.map